'use client';

import { FC, useCallback, useEffect } from 'react';
import { EVENT_CONSENT_CHANGED } from '../utils/event-names';

export const ConsentDialogObserver: FC = () => {
  let handleConsentChange = useCallback(() => {
    window.dispatchEvent(new Event(EVENT_CONSENT_CHANGED));
  }, []);

  // Let's set up the callback for the mutation observer.
  let callback = useCallback(
    (mutations: MutationRecord[], observer: MutationObserver) => {
      // Let's check if the mutations contain any added nodes.
      let nodeList = document.body.querySelectorAll(
        [
          '#__tealiumGDPRecModal #privacy_pref_optin',
          '#__tealiumGDPRecModal #privacy_pref_optout',
          '#__tealiumGDPRcpPrefs #preferences_prompt_submit',
          '#__tealiumGDPRcpPrefs #accept_all_button',
        ].join(', '),
      );

      let elements = [...nodeList];

      // If there are no elements, we don't need to do anything.
      if (elements.length === 0) {
        return;
      }

      // Let's sneak in a click event on the elements that were added to the DOM.
      elements.forEach(element => {
        element.addEventListener('click', () =>
          setTimeout(handleConsentChange, 50),
        );
      });
    },
    [handleConsentChange],
  );

  // Let's set up the mutation observer to watch for changes in the body of the document.
  useEffect(() => {
    let observer = new MutationObserver(callback);

    observer.observe(document.body, { childList: true });

    return () => {
      observer.disconnect();
    };
  }, []);

  // No UI to render, just the observer.
  return null;
};
